import { combineReducers } from "@reduxjs/toolkit";
import { modelsReducers } from "../../../app/state/modelsSlice/slice";
import { storageObjectReducers } from "../../../app/state/storageObjectSlice/slice";
import { chatCompletionReducers } from "../../../common/ChatCompletions/redux/slice";
import { headerNavigationReducers } from "../../../common/Header/redux/slice";
import { sidebarReducers } from "../../../common/Sidebar/redux/slice";
import { assistantsReducer } from "../../../features/Assistants/redux/slice";
import { authReducers } from "../../../features/Auth/redux/slice";
import { casesReducer } from "../../../features/Cases/redux/slice";
import { classifierReducer } from "../../../features/Classification/redux/slice";
import { comparisonReducers } from "../../../features/Comparison/redux/slice";
import { databaseReducers } from "../../../features/Database/redux/slice";
import { dialogsReducer } from "../../../features/Dialog/redux/slice";
import { editorReducers } from "../../../features/Editor/redux/slice";
import { chatbotReducers } from "../../../features/Chatbot/redux/slice";
import { embeddingsReducers } from "../../../features/Embeddings/redux/slice";
import { extraAppReducers } from "../../../features/ExtraApp/redux/slice";
import { audioTranscriptionReducer } from "../../../features/Modals/AudioTranscription/redux/slice";
import { staticTokenReducers } from "../../../features/Modals/StaticTokenCreatorTable/redux/slice";
import { practicumReducers } from "../../../features/Practicum/redux/slice";
import { researchReducers } from "../../../features/ResearchService/redux/slice";
import { meetingReducers } from "../../../features/Meeting/redux/slice";
import { complianceReducers } from "../complianceSlice/slice";
import { i18nReducer } from "../../i18n/redux/slice";
import { stylistReducer } from "../../../features/Stylisation/redux/slice";
import { modalReducers } from "../../../app/state/modalSlice/slice";
import { filesReducers } from "../../../features/Files/redux/slice";
import { notificationReducers } from "../../../app/state/notificationSlice/slice";
import { popoverReducers } from "../../../app/state/popoverSlice/slice";
import { menuReducers } from "../../../app/state/menuSlice/slice";
import { skillsReducers } from "../../../features/Skills/redux/slice";
import { agentReducers } from "../../../features/Agents/redux/slice";
import { uiReducers } from "../../../app/state/uiSlice/slice";
import { schemasReducers } from "../../../features/Schemas/redux/slice";
import { deerflowReducers } from "../../../features/DeerFlow/redux/slice";
import { profileReducers } from "../../../features/Modals/ProfileModal/redux/slice";

export const reducer = combineReducers({
  agentState: agentReducers,
  assistantsState: assistantsReducer,
  audioTranscriptionState: audioTranscriptionReducer,
  authState: authReducers,
  chatCompletionState: chatCompletionReducers,
  casesState: casesReducer,
  classifierState: classifierReducer,
  comparisonState: comparisonReducers,
  complianceState: complianceReducers,
  databaseState: databaseReducers,
  deerFlowState: deerflowReducers,
  dialogsState: dialogsReducer,
  editorState: editorReducers,
  chatbotState: chatbotReducers,
  extraAppState: extraAppReducers,
  embeddingsState: embeddingsReducers,
  filesState: filesReducers,
  meetingState: meetingReducers,
  modelsState: modelsReducers,
  headerNavigationState: headerNavigationReducers,
  i18n: i18nReducer,
  modalState: modalReducers,
  notificationState: notificationReducers,
  practicumState: practicumReducers,
  popoverState: popoverReducers,
  profileState: profileReducers,
  menuState: menuReducers,
  schemasState: schemasReducers,
  sidebarState: sidebarReducers,
  staticTokenState: staticTokenReducers,
  storageObjectState: storageObjectReducers,
  skillsState: skillsReducers,
  stylistState: stylistReducer,
  researchState: researchReducers,
  uiState: uiReducers,
});
